import { http } from "@/utils/http";
export const getRestCity = data => {
  return http.request("get", `/rest/cities/${data}`);
};
/** 酒店列表 */
export const getRestTpHotel = data => {
  return http.request("get", `/rest/moduleTpHotels/${data}`, {
    params: {
      populate: JSON.stringify([
        "nameRef",
        "addressRef",
        "introRef",
        "videoRefs"
      ])
    }
  });
};

/**
 * 获取文章详情
 * @param id 文章id
 * @returns
 */
export function getArticleDetail(id) {
  return http.get(`/rest/articles/${id}`);
}

export const getChannelFleet = id => {
  return http.request("get", `/rest/channelFleets/${id}`, {});
};

export const getLoyaltyPrograms = () => {
  return http.request("get", `/rest/loyaltyPrograms`, {});
};

export const getTransactionList = () => {
  return http.request("get", `/rest/transactions`, {
    params: {
      populate: [
        "sourceRef",
        "sourceRef",
        "orderRef",
        "statementRef",
        "destinationRef"
      ]
    }
  });
};

export const updateComments = data => {
  return http.request("patch", `/rest/comments/${data._id}`, { data });
};

export const getComments = data => {
  return http.request("get", `/rest/comments`, { params: data });
};

export const getCommentsCount = data => {
  return http.request("get", `/rest/comments/count`, { params: data });
};

export const getShopBrands = data => {
  return http.request("get", `/rest/shopBrands`, { params: data });
};

export const getShopGroup = data => {
  return http.request("get", `/rest/shopGroups`, { params: data });
};

export const getHotelChains = data => {
  return http.request("get", `/rest/tpHotelChains`, { params: data });
};

/**
 * 视频处理
 *
 */
export const getVideoConfig = data => {
  return http.post("/rest/videos", { data });
};


/**
 * 获取城市列表数据
 * @param query 城市id
 * @returns
 */
export const getCityList = async (query) => {
  const select = JSON.stringify({
    city: 1,
    translation: 1,
    country: 1,
    timezone: 1,
    hot: 1,
    continent: 1,
    area: 1
  });
  return http.get("/rest/cities/", {
    query: JSON.stringify(query),
    sort: JSON.stringify({ order: 1 }),
    select
  });
};
